import React, { useContext } from 'react'
import { PanelStyleContext } from '../../../../elem/panel/PanelStyleContext'
import { DataContext } from '../DataContext'

const ChartTabs = () => {
    const { visibleChartTab, setVisibleChartTab, toggleTimeWindowDropdown, toggleAnalyteWindowDropdown } = useContext(DataContext)
    const { tabClass } = useContext(PanelStyleContext)
    return (
        <div className={`tabs is-small is-boxed is-fullwidth ${tabClass} chartTabs`}>
            <ul>
                <li
                    className={visibleChartTab === 'waterLevel' ? 'is-active' : ''}
                    onClick={() => {
                        // when we toggle water level chart, hide dropdowns if they are displayed
                        setVisibleChartTab('waterLevel')
                        toggleTimeWindowDropdown(false)
                        toggleAnalyteWindowDropdown(false)
                    }}
                >
                    <div>
                        <span>Water Level Measurements</span>
                    </div>
                </li>
                <li
                    className={visibleChartTab === 'sampleResult' ? 'is-active' : ''}
                    onClick={() => setVisibleChartTab('sampleResult')}
                >
                    <div>
                        <span>Sample Results</span>
                    </div>
                </li>
            </ul>
        </div>
    )
}

export default ChartTabs